const AddContactModal = () => import('../add-contact-modal/index.vue');

export default {
    name: 'AddContactButton',
    
    methods: {
        addContact() {
            this.$ionic.modalController.create({
                component: AddContactModal
            }).then(m => m.present());
        }
    }
};